import { render, staticRenderFns } from "./NewContactsForm.vue?vue&type=template&id=5ce5827e&scoped=true"
import script from "./NewContactsForm.vue?vue&type=script&lang=js"
export * from "./NewContactsForm.vue?vue&type=script&lang=js"
import style0 from "./NewContactsForm.vue?vue&type=style&index=0&id=5ce5827e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce5827e",
  null
  
)

export default component.exports